import React, { useState, useEffect } from "react";
import {
    Button,
    Chip,
    colors,
    Container,
    Grid,
    Hidden,
    makeStyles,
    Paper,
    Typography,
} from "@material-ui/core";
import useFetchURL from "../../../../../components/Hooks/useFetchURL";
import { uri } from "../../../../../help/Api";
import TotalCard from "../../../../../components/TotalCard";
import { useHistory } from "react-router-dom";
import {
    useStylesHed,
    useStylesSpDial,
    useStylesUiElemment,
} from "../../../../../St/comps/UseStyle";
import { insh as inshst } from "../../../../../Context/InshSt";
import ScannerIcon from "@material-ui/icons/Scanner";
import LockIcon from "@material-ui/icons/Lock";

import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import PrintIcon from "@material-ui/icons/Print";
import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";
import i18next from "i18next";
import { TableChart } from "@material-ui/icons";
import { CSVLink } from "react-csv";
import moment from "moment";
import axios from "axios";
import toast from "react-hot-toast";

import { sto } from "../../../../../Context/InshData";
import PumpShiftsForm from "./PumpShiftsForm";
import PumpShiftsTable from "./PumpShiftsTable";
import PumpShiftsReportTable from "./PumpShiftsReportTable";


const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    headerTitle: {
        backgroundColor: colors.green[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: colors.blue[50],
        borderColor: colors.blue[300],
    },
}));

export default function PumpShifts(props) {
    const { AutoOptions, isPurches } = props;
    const { t } = useTranslation(["forms", "translation"]);

    const shiftOptions = [
        { id: 0, name: t("opened") },
        { id: 1, name: t("closed") },
    ];
    const SearchCloseReports = {
        transFrom: {},
        transTo: {},
        dateFrom: moment(new Date()).format('YYYY-MM-DD'),
        timeFrom: moment(new Date()).format('HH:mm'),
        dateTo: moment(new Date()).format('YYYY-MM-DD'),
        timeTo: moment(new Date()).format('HH:mm'),
        trans_Close: shiftOptions[0],
        user: AutoOptions.Users[0],
        branch: sto.branchi,
        trans_no: AutoOptions?.pumpsTrans[0],
    };
    function GetFromOptions(id, options) {
        const index = options?.findIndex((op) => op.id == id);
        return options[index];
    }


    const [rptParams, setRptParams] = React.useState(SearchCloseReports);

    const [optionsShifts, setOptionsShifts] = useState(AutoOptions?.pumpsTrans);
    const [tableShifts, setTableShifts] = useState(AutoOptions?.pumpsTrans);
    const [chooseShifts, setChooseShifts] = useState({});


    const [allowShifts, setAllowShifts] = useState(true);
    const [showButtons, setShowButtons] = useState(false);




    const classes = useStyles();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    const [data, setData] = useState([]);
    const [dataShifts, setDataShifts] = useState([]);
    const [shiftsRow, setShiftsRow] = useState({});

    const [fetching, setFetching] = useState(false);
    const [fetchingS, setFetchingS] = useState(false);

    const [sum, setSum] = useState(false);
    const [showDef, setShowDef] = useState(true);


    const viewHandle = async () => {
        if (rptParams.trans_Close.id === 1) {
            setDataShifts([]);
            setFetchingS(true);
            await axios
                .get(
                    uri +
                    `RptSales/closePumpsShifts?branch=${rptParams?.branch}
    &&transFrom=${rptParams?.transFrom?.trans_no}
    &&transTo=${rptParams?.transTo?.trans_no}`
                )
                .then((res) => {
                    setTableShifts(res?.data?.pumpsShifts);
                    // setTableShifts(AutoOptions?.pumpsTrans);
                    setFetchingS(false);
                })
                .catch((err) => {
                    // console.log(err);
                    // toast.err("يوجد خطأ في الجلب");
                    setFetchingS(false);
                });
        } else {
            reloadGets();
        }
    };
    const reloadGets = () => {
        const tb = {
          // wait: true,
          PumpsTrans: true,
          parms: {
            iempid: sto.empi,
            branch:sto.branchi,
          },
        };
        axios
          .post(uri + "GetD", tb)
          .then((res) => {
            setTableShifts(res.data?.pumpsTrans);
            // AutoOptions?.pumpsTrans=res.data?.pumpsTrans;
          })
          .catch((error) => {
          });
      };


    const viewSearch = async (rowData) => {
        setChooseShifts(rowData);
        if (rowData.status === 0) {
            setData([]);
            setFetching(true);
            setShiftsRow(rowData);
            await axios
                .get(
                    uri +
                    `RptSales/pumpsShiftSub?branch=${rowData?.branch}
        &&trans_no=${rowData?.trans_no}`
                )
                .then((res) => {
                    setData(res.data);
                    console.log(" the data is", res.data);
                    setFetching(false);
                    setShowButtons(true);
                })
                .catch((err) => {
                    setFetching(false);
                    console.log(err);
                    // toast.err("يوجد خطأ في الجلب");
                    setData([]);
                    setShowButtons(false);
                });
        } else {
            setShowButtons(false);
            setData([]);
            setFetching(true);
            setShiftsRow(rowData);
            await axios
                .get(
                    uri +
                    `RptSales/pumpsShiftSubClose?branch=${rowData?.branch}
        &&trans_no=${rowData?.trans_no}`
                )
                .then((res) => {
                    setData(res.data);
                    console.log(" the data is", res.data);
                    setFetching(false);
                    setShowButtons(false);
                })
                .catch((err) => {
                    setFetching(false);
                    console.log(err);
                    // toast.err("يوجد خطأ في الجلب");
                    setData([]);
                    setShowButtons(false);
                });
        }


    };
    const his = useHistory();

    const shitCloseEnd = (rowdata) => {
        var otherData = dataShifts?.shiftsAll.filter((obj) => obj.transNo !== rowdata.transNo);
        setDataShifts([...otherData]);
        setShowButtons(false);
    }

    const printHandleA4 = (dataS, dataT) => {
        if (data.lenght == 0) {
            alert("لاتوجد بيانات");
        } else {
            setData([]);
            // shitCloseEnd(shiftsRow);
            setShiftsRow({});
            const info = {
                data: dataT?.pupmsTransSub,
                tot:{},
                from: 'الحركة اليومي',
                kind:2,
                title: ' تقرير ملخص  اقفال وردية  ',
                user:"",
                fDate: dataS?.fromData,
                tDate: dataS?.fromDate,
                trans_no: dataS?.trans_no,
                nDate: moment(new Date()).format('YYYY-MM-DD'),
                // totsp:rpt.totSelcPeriod,balncsp:rpt.balncSelcPeriod
            }
            localStorage.setItem("iInfos", JSON.stringify(info));
            his.push({ pathname: "/ReviewShifts" });
            window.location.reload(true);
        }
    };

    const printHandleCashier = (dataS, dataT) => {

        if (data.lenght == 0) {
            alert("لاتوجد بيانات");
        } else {
            setData([]);
            setShiftsRow({});
            const info = {
                // rout:rpt.parms,
                data: dataT?.pupmsTransSub,
                tot: dataT?.totals,
                from: 'الحركة اليومي',
                title: ' تقرير اقفال وردية الموظف ',

                stock: "",
                safe: "",
                user: rptParams.user.name,
                fDate: dataS.minDate,
                tDate: dataS.maxDate,
                transNo: dataS.transNo,
                nDate: moment(new Date()).format('YYYY-MM-DD'),
                // totsp:rpt.totSelcPeriod,balncsp:rpt.balncSelcPeriod
            }
            localStorage.setItem("iInfos", JSON.stringify(info));
            his.push({ pathname: "/CahierShifts" });
            window.location.reload(true);
        }
    };

    const loadOptinsShift = async (fromData, todate) => {
        setOptionsShifts([]);
        await axios
            .get(
                uri +
                `RptSales/closePumpsOptins?dateF=${fromData + ' ' + rptParams?.timeFrom}
        &&dateT=${todate + ' ' + rptParams?.timeTo}
        &&branch=${rptParams?.branch}`
            )
            .then((res) => {
                setAllowShifts(false);
                setOptionsShifts(res?.data?.pumpsOptions);
            })
            .catch((err) => {
                console.log(err);
                // toast.err("يوجد خطأ في الجلب");
            });
    };


    const CloseShift = (props, dataR, dataST) => {

        const _pumptrans = {
            ...chooseShifts,
        };
        let _pumpTransSub = data?.pupmsTransSub?.map(x => {
            return {
                trans_no: x.trans_no,
                pump_id: x?.pump_id,
                branch: x?.branch,
                countBefore: x?.countBefore,
                countAfter: x?.countAfter,
                totVal: x?.totVal,
                totSale: x.totSale,
            }
        })
        const model = {
            _pumptrans: _pumptrans,
            _pumpTransSub: _pumpTransSub,
        };
        if (chooseShifts?.status != null) {

            if (chooseShifts?.status == 1) {
                alert("الوردية قد تم اغلاقها مسبقا")
            }
            else {
                console.log("the curre data is ", model);
                axios
                    .post(uri + "PumpsColse", model)
                    .then((res) => {
                        toast.success("تم الاقفال بنجاح");
                        setShowButtons(false);
                        setData([]);
                        setTableShifts([]);
                        setChooseShifts({});
                        reloadGets();

                        if (props === "close") {

                        } else if (props === "small") {
                            printHandleCashier(dataR, dataST);

                        }
                        else if (props === "big") {
                            printHandleA4(dataR, dataST);

                        }

                    })
                    .catch((res) => {
                        //  alert("تم إضافة الصنف هذا مسبقا");
                        // ButtonSuccess("save", 1000);
                        toast.success("لم يتم الاقفال بنجاح");

                    })
            }
        }

    };


    const changTFieldFrom = (prop) => (e) => {
        setRptParams({ ...rptParams, [prop]: e.target.value });
        loadOptinsShift( e.target.value, rptParams?.dateTo);
    };

    const changTFieldTo = (prop) => (e) => {
        setRptParams({ ...rptParams, [prop]: e.target.value });
        loadOptinsShift( rptParams?.dateFrom, e.target.value);
    };
    const onChangeData = (propName) => (event) => {
        setRptParams({ ...rptParams, [propName]: event.target.value });
    };
    const onChangeAutoData = (propName, newValue) => {
        setRptParams({ ...rptParams, [propName]: newValue });
    };
    const onChangeAutoTransC = (propName, newValue) => {
        setRptParams({ ...rptParams, [propName]: newValue });
        if (newValue.id==1){
            loadOptinsShift( rptParams?.dateFrom, rptParams?.dateTo);
        }else {
            setOptionsShifts(AutoOptions?.pumpsTrans);
        }
    };


    return (
        <div className={classes.root}>
            <Grid container item xs={12}>
                <Typography
                    size="small"
                    className={classes.headerTitle}
                    color="primary"
                >
                    {t("shift_close_report")}
                </Typography>
            </Grid>
            <Typography
                component="div"
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
            >
                <Grid container item lg={12} md={12} sm={12} xm={12} className={clasui.rootchip}>

                    <Grid container item lg={6} md={6} sm={6} xm={12} className={clasui.rootchip}>

                        <Container
                            component={Paper}
                            maxWidth={false}
                            style={{
                                padding: "10px",
                                paddingBottom: "0px",
                                borderBottomColor: colors.green[300],
                                borderBottomWidth: "1px",
                                borderBottomStyle: "solid",
                            }}
                        >
                            <PumpShiftsForm
                                {...{
                                    rptParams,
                                    onChangeAutoData,
                                    optionsShifts,
                                    allowShifts,
                                    shiftOptions,
                                    onChangeAutoTransC,
                                    changTFieldFrom,
                                    changTFieldTo,

                                }}
                            />
                            <Grid item container justifyContent="center" xs={12}>
                                <BeatLoader loading={fetchingS} color={colors.green[300]} />
                                {!fetchingS && (
                                    <PumpShiftsTable
                                        {...{
                                            data: tableShifts ? tableShifts : [],
                                            viewSearch, CloseShift, showButtons
                                        }}
                                    />
                                )}

                            </Grid>
                            <Grid
                                item
                                container

                                justifyContent="center"
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                spacing={1}
                            >
                                <Hidden smUp={["sm"]}>

                                    <Grid item>
                                        <Button
                                            disabled={fetching}
                                            variant="contained"
                                            startIcon={<ScannerIcon />}
                                            size="large"
                                            style={
                                                (inshst.sal.iconBtn,
                                                    { borderRadius: 0 })
                                            }
                                            className={[clasui.button]}
                                            onClick={() => viewHandle()}
                                        >
                                            {t("forms:show")}
                                        </Button>
                                    </Grid>
                                </Hidden>

                                <Hidden only={["xs"]}>

                                    <Grid item>
                                        <Button
                                            disabled={fetchingS}
                                            variant="contained"
                                            startIcon={<ScannerIcon />}
                                            size="large"
                                            style={
                                                (inshst.sal.iconBtn,
                                                    { borderRadius: 0 })
                                            }
                                            className={[clasui.button]}
                                            onClick={() => viewHandle()}
                                        >
                                            {t("forms:view")}
                                        </Button>
                                    </Grid>
                                </Hidden>


                                {showButtons && (
                                    <Grid item>
                                        <Button
                                            disabled={fetching}
                                            variant="contained"
                                            startIcon={<LockIcon />}
                                            color="primary"
                                            size="large"
                                            className={[clasui.button]}
                                            style={
                                                (inshst.sal.iconBtn,
                                                    { borderRadius: 0 })
                                            }
                                            onClick={() => CloseShift("close", shiftsRow, data)}

                                        >
                                            {t("closing")}
                                        </Button>
                                    </Grid>
                                )}
                                {showButtons && (
                                    <Grid item>
                                        <Button
                                            disabled={fetching}
                                            variant="contained"
                                            startIcon={<PrintIcon />}
                                            color="primary"
                                            size="large"
                                            className={[clasui.button]}
                                            style={
                                                (inshst.sal.iconBtn,
                                                    { borderRadius: 0 })
                                            }
                                            onClick={() => CloseShift("big", shiftsRow, data)}
                                        >
                                            {t("large_print_and_close")}
                                        </Button>
                                    </Grid>
                                )}
                  
                                {shiftsRow?.trans_no !=null && (
                                    <Grid item>
                                        <Button
                                            disabled={fetching}
                                            variant="contained"
                                            startIcon={<PrintIcon />}
                                            color="primary"
                                            size="large"
                                            className={[clasui.button]}
                                            style={
                                                (inshst.sal.iconBtn,
                                                    { borderRadius: 0 })
                                            }
                                            onClick={() => printHandleA4(shiftsRow, data)}
                                        >
                                            {t("great-view")}
                                        </Button>
                                    </Grid>
                                )}
                                <Grid item>
                                    <Button
                                        variant="contained"
                                        startIcon={<KeyboardReturnSharpIcon />}
                                        color="secondary"
                                        size="large"
                                        className={[clasui.button, clasSp.clcan]}
                                        style={
                                            (inshst.sal.iconBtn,
                                                { borderRadius: 0 })
                                        }
                                        onClick={() => his.goBack()}
                                    >
                                        {t("forms:exit")}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Container>

                        <br />
                    </Grid>
                    <Grid container lg={6} md={6} sm={6} xm={12} className={clasui.rootchip}>
                        <Container
                            component={Paper}
                            maxWidth={false}
                            style={{
                                padding: "10px",
                            }}
                        >
                            <Grid container justifyContent="center">
                                <Grid item container justifyContent="center" xs={12}>
                                    <BeatLoader loading={fetching} color={colors.green[300]} />
                                    {!fetching && (
                                        <PumpShiftsReportTable
                                            {...{
                                                data: data?.pupmsTransSub ? data.pupmsTransSub : [],
                                            }}
                                        />
                                    )}
                                </Grid>
                            </Grid>
                        </Container>
                    </Grid>
                </Grid>
            </Typography>
        </div>
    );
}
